import { render, staticRenderFns } from "./BaseFooterTitle.vue?vue&type=template&id=494cc308&scoped=true&"
import script from "./BaseFooterTitle.vue?vue&type=script&lang=js&"
export * from "./BaseFooterTitle.vue?vue&type=script&lang=js&"
import style0 from "./BaseFooterTitle.vue?vue&type=style&index=0&id=494cc308&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494cc308",
  null
  
)

export default component.exports